<template>
  <div class="basicDataSummary">
    <div class="filters">
      <el-form :inline="true">
        <!-- 时间 -->
        <el-form-item>
          <el-date-picker v-model="datevalues" type="daterange" :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')" :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"></el-date-picker>
        </el-form-item>
        <!-- 提交button -->
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
        <el-button class="jump-btn" type="primary" @click="jump()">{{$t('lang.btn_backaddpropertyManage')}}</el-button>
      </el-form>
    </div>
    <div class="topBox">
      <div class="topLeftBox">
        <el-card class="topLeftCard">
          <div class="cardTitle">基础信息</div>
          <div class="topLeftInfo">
            <div class="leftFlex" style="flex: 1 25%;">
              <span class="lebelText">姓名：</span>
              <p class="infoText" style="fontSize: 22px;" :class="staffData.staffName.length>16?'smallFont':''">
                {{staffData.staffName}}</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">工龄：</span>
              <p class="infoText" v-if="staffData.workYears">{{staffData.workYears}}</p>
              <p class="infoText" v-else>--</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">性别：</span>
              <p class="infoText" style="fontSize: 22px;" v-if="staffData.gender==1">女</p>
              <p class="infoText" style="fontSize: 22px;" v-if="staffData.gender==2">男</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">管辖户数：</span>
              <p class="infoText">{{staffData.staffRecordCount}}</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">多种经营金额：</span>
              <p class="infoText" :class="staffData.sklTotalPrice>=100000?'smallFont1':''">{{staffData.sklTotalPrice}}
              </p>
            </div>
            <!-- <div class="leftFlex" style="opacity:0">
              <span class="lebelText"></span>
              <p class="infoText"></p>
            </div> -->
            <!-- <div class="leftFlex wid100">
              <span class="">人员权限：</span>
              <div style="flex:1;">
                <el-tag class="infoText infoTag" :class="tag_bg[index%3]"  v-for="(item,index) in staffData.maintainTypes" :key="index"
                  effect="dark">{{item.maintainTypeName}}
                </el-tag>
              </div>
            </div> -->
            <div class="leftFlex wid100">
              <span class="">服务项目：</span>
              <div style="flex:1;">
                <el-tag class="infoText infoTag" :class="tag_bg[index%3]" v-for="(item,index) in staffData.staffGardens" :key="index"
                  effect="dark">{{item.Name}}
                </el-tag>
              </div>
            </div>
            <div class="leftFlex wid100">
              <span class="">管理区域：</span>
              <div style="flex:1;">
                <el-tag class="infoText infoTag" :class="tag_bg[index%3]" v-for="(item,index) in staffData.staffGardenGrid" :key="index"
                  effect="dark">{{item.gardenName}}：{{item.unitNames}}
                </el-tag>
              </div>
            </div>
            <div class="leftFlex" style="opacity:0">
              <span class="lebelText"></span>
              <p class="infoText"></p>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <div class="topBox">
      <div class="topLeftBox">
        <el-card class="topLeftCard">
          <div class="cardTitle">多指标数据分析</div>
          <div class="cardList">
            <div class="lineBox1">
              <!-- 报事总数 -->
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">业主工单</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy01.png" />
                    <p class="cardInfo">{{staffData.yezhuMaintain}}</p>
                  </div>
                </div>
              </el-card>
              <!-- 投诉总数 -->
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">物业工单</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy02.png" />
                    <p class="cardInfo">{{staffData.wuyeMaintain}}</p>
                  </div>
                </div>
              </el-card>
              <!-- 业主标签 -->
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">巡检工单</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy03.png" />
                    <p class="cardInfo">{{staffData.jobMaintain}}</p>
                  </div>
                </div>
              </el-card>
              <!-- 业主档案（附件） -->
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">报单数量</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy04.png" />
                    <p class="cardInfo">{{staffData.baodanMaintain}}</p>
                  </div>
                </div>
              </el-card>
              <!-- 业主变更信息记录 -->
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">接单数量</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy05.png" />
                    <p class="cardInfo">{{staffData.jiedanMaintain}}</p>
                  </div>
                </div>
              </el-card>
              <!-- 业主开门记录 -->
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">居家服务工单</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy06.png" />
                    <p class="cardInfo">{{staffData.jujiafuwuMaintain}}</p>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">居家服务收入</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy13.png" />
                    <p class="cardInfo">{{staffData.maintainPriceStaff}}</p>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">历史工单数</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy07.png" />
                    <p class="cardInfo">{{staffData.hMaintain}}</p>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">日均报单量</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy12.png" />
                    <p class="cardInfo">{{staffData.oneDayMaintainCount>0?staffData.oneDayMaintainCount:0}}</p>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">子工单均量</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy14.png" />
                    <p class="cardInfo">{{staffData.parentMaintain}}</p>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">GBA接单量</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy18.png" />
                    <p class="cardInfo">{{staffData.gbaJiedan}}</p>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">业主投诉量</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy17.png" />
                    <p class="cardInfo">{{staffData.complainMaintain}}</p>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">业主标签户均值</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy11.png" />
                    <p class="cardInfo">{{staffData.userDrawCount}}</p>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">信用值</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy15.png" />
                    <p class="cardInfo">{{staffData.serviceCommission}}</p>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">APP绑定率</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy16.png" />
                    <p class="cardInfo">{{staffData.appBind?(staffData.appBind.T_A4_6_*100)+'%':'--'}}</p>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">APP打开次数</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy08.png" />
                    <p class="cardInfo">{{staffData.staffAppCount}}</p>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">蓝牙门禁使用次数</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy09.png" />
                    <p class="cardInfo">{{staffData.doorDeviceRecordCount}}</p>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card">
                <div>
                  <p class="cardTitle1">蓝牙梯控使用次数</p>
                  <div class="cardCont">
                    <img class="cardImg" src="../../../assets/imgs/icon_wy10.png" />
                    <p class="cardInfo">{{staffData.liftRecordCount}}</p>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
          <!-- <div class="topLeftInfo">
            <div class="leftFlex">
              <span class="lebelText">业主工单：</span>
              <p class="infoText">{{basicData.staffCount}}</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">物业工单：</span>
              <p class="infoText">{{basicData.staffCount}}</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">巡检工单：</span>
              <p class="infoText">
                {{basicData.staffCount}}</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">报单数量：</span>
              <p class="infoText">{{basicData.staffCount}}</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">接单数量：</span>
              <p class="infoText">{{basicData.staffCount}}</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">居家服务工单数：</span>
              <p class="infoText">{{basicData.staffCount}}</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">历史工单数量：</span>
              <p class="infoText">{{basicData.staffCount}}</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">APP打开次数：</span>
              <p class="infoText">{{basicData.staffCount}}</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">蓝牙门禁使用次数：</span>
              <p class="infoText">{{basicData.staffCount}}</p>
            </div>
            <div class="leftFlex" style="opacity:0">
              <span class="lebelText"></span>
              <p class="infoText"></p>
            </div>
            <div class="leftFlex" style="opacity:0">
              <span class="lebelText"></span>
              <p class="infoText"></p>
            </div>
            <div class="leftFlex" style="opacity:0">
              <span class="lebelText"></span>
              <p class="infoText"></p>
            </div>
            <div class="leftFlex" style="opacity:0">
              <span class="lebelText"></span>
              <p class="infoText"></p>
            </div>
          </div> -->
        </el-card>
      </div>
    </div>
    <div class="contentBox">
      <el-card class="contentCard leftWidthBox">
        <div class="cardTitle">接单及时率统计</div>
        <div class="container">
          <div id="echart1"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">工单24小时反馈率统计</div>
        <div class="container">
          <div id="echart2"></div>
        </div>
      </el-card>

    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="cardTitle">工单好评率统计</div>
        <div class="container">
          <div id="echart3"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">本年物业费收缴率统计</div>
        <div class="container">
          <div id="echart4"></div>
        </div>
      </el-card>
    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="cardTitle">对应管理片区业主好评率统计</div>
        <div class="container">
          <div id="echart6"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">对应管理片区24H完结率统计</div>
        <div class="container">
          <div id="echart7"></div>
        </div>
      </el-card>
    </div>
    <div class="contentBox" style="display:none;">
      <el-card class="contentCard">
        <div class="cardTitle">雷达图</div>
        <el-select style="display:none;" v-model="value" multiple :multiple-limit="2" filterable placeholder="请选择" @change="selectChanged">
          <el-option v-for="item in staffList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div class="container1">
          <div id="echart5"></div>
        </div>
      </el-card>
      <el-card class="contentCard" style="opacity:0">
        <!-- <div class="cardTitle">雷达图</div>
        <div class="container1">
          <div id="echart5"></div>
        </div> -->
      </el-card>
    </div>
  </div>
</template>

<script>
  /**
   *@ClassName:basicDataSummary
   *@Description:基础数据汇总统计
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2022-11-9
   */
  // import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.basicDataSummary',
    data() {
      return {
        staffId: '',
        gardenId: this.$store.getters.gardenId, // 园区id
        staffData: {
          staffName: ''
        }, // 基础信息
        staffList: [],
        value: [],
        startTs: '',
        endTs: '',
        datevalues: '',
        nameArr: [],
        pkArr: [],
        pkStaffList: [],
        tag_bg: ['bg1', 'bg2', 'bg3']
      }
    },
    created() {
      this.staffId = this.$route.query.id
      // this.staffId = 110647
      // this.staffId = 494
      this.getYearNow()
      this.getDateNow()
      this.getStaffList()
      this.getStaffData()
      this.getDoorData()
    },
    methods: {
      // 返回list页面
      jump() {
        this.$router.push({
          name: 'propertyManageList'
        })
      },
      // 获取今年1月1日时间
      getYearNow() {
        let y = new Date().getFullYear()
        let time = Date.parse(`${y}-1-1`)
        this.startTs = time
        console.log('今年1月1日时间戳===' + time)
      },
      // 获取当前时间
      getDateNow() {
        var date = new Date()
        var time = date.getTime()
        this.endTs = time
        console.log('当前时间戳===' + time)
      },
      // 获取pk人员列表数据
      getStaffList() {
        // let loading = this.$loading()
        this.$get(
          `/staffAll?staffId=${this.staffId}`
        ).then(
          res => {
            // loading.close()
            if (res && res.errCode === 0) {
              console.log(res.data)
              this.staffList = res.data.filter(item => item.value !== this.staffId)
            }
          },
          error => {
            // loading.close()
            this.$message.error(error)
          }
        )
      },
      // 选择pk人员
      selectChanged(value) {
        this.pkStaffList = value
        console.log(this.pkStaffList)
        if (value.length == 0) {
          this.pkArr = []
          this.nameArr = []
          this.getPkData(this.staffId)
        } else {
          let pkArr = []
          let ldObj = {
            value: [this.staffData.yezhuMaintain, this.staffData.wuyeMaintain, this.staffData.jobMaintain, this
              .staffData.baodanMaintain, this.staffData
              .jiedanMaintain, this.staffData.jujiafuwuMaintain
            ],
            name: this.staffData.staffName
          }
          pkArr.push(ldObj)
          this.pkArr = pkArr
          let nameArr = []
          nameArr.push(ldObj.name)
          this.nameArr = nameArr
          if (value.length == 1) {
            this.getPkData(value[0])
          } else if (value.length == 2) {
            for (let i = 0; i < value.length; i++) {
              this.getPkData(value[i])
            }
          }
        }
      },
      // 获取pk人员信息数据
      getPkData(id) {
        let loading = this.$loading()
        this.$get(
          `/selectStaffData?startTs=${this.startTs}&endTs=${this.endTs}&staffId=` + id
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              let ldObj = {
                value: [res.yezhuMaintain, res.wuyeMaintain, res.jobMaintain, res.baodanMaintain, res
                  .jiedanMaintain, res.jujiafuwuMaintain
                ],
                name: res.staffName
              }
              let pkArr = this.pkArr
              let nameArr = this.nameArr
              pkArr.push(ldObj)
              nameArr.push(ldObj.name)
              this.pkArr = pkArr
              this.nameArr = nameArr
              this.getLoadEcharts5(pkArr)
              console.log(this.pkArr)
              console.log(this.nameArr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 根据时间段查询数据
      commit() {
        console.log(this.pkStaffList)
        if (this.datevalues) {
          this.startTs = this.datevalues[0]
          this.endTs = this.datevalues[1]
          this.getStaffData()
          this.getDoorData()
          if (this.pkStaffList.length > 0) {
            for (let i = 0; i < this.pkStaffList.length; i++) {
              this.getPkData(this.pkStaffList[i])
            }
          }
        } else {
          this.$message.info('请选择查询起止日期')
          // this.getYearNow()
          // this.getDateNow()
          // this.getStaffData()
          // if (this.pkStaffList.length > 0) {
          //   for (let i = 0; i < this.pkStaffList.length; i++) {
          //     this.getPkData(this.pkStaffList[i])
          //   }
          // }
        }
      },
      // 获取基本信息数据
      getStaffData() {
        let loading = this.$loading() 
        this.$get(
          `/selectStaffData?startTs=${this.startTs}&endTs=${this.endTs}&staffId=${this.staffId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.$set(this.staffData, 'staffName', res.staffName)
              this.$set(this.staffData, 'workYears', res.workYears)
              this.$set(this.staffData, 'gender', res.gender)
              this.$set(this.staffData, 'staffRecordCount', res.staffRecordCount)
              this.$set(this.staffData, 'sklTotalPrice', res.sklTotalPrice)
              this.$set(this.staffData, 'maintainTypes', res.maintainTypes)
              this.$set(this.staffData, 'staffGardens', res.staffGardens)
              this.$set(this.staffData, 'yezhuMaintain', res.yezhuMaintain)
              this.$set(this.staffData, 'wuyeMaintain', res.wuyeMaintain)
              this.$set(this.staffData, 'jobMaintain', res.jobMaintain)
              this.$set(this.staffData, 'baodanMaintain', res.baodanMaintain)
              this.$set(this.staffData, 'jiedanMaintain', res.jiedanMaintain)
              this.$set(this.staffData, 'jujiafuwuMaintain', res.jujiafuwuMaintain)
              this.$set(this.staffData, 'hMaintain', res.hMaintain)
              this.$set(this.staffData, 'staffAppCount', res.staffAppCount)
              this.$set(this.staffData, 'maintainOverTimeByStaff', res.maintainOverTimeByStaff)
              this.$set(this.staffData, 'maintainInTimeFinishByStaff', res.maintainInTimeFinishByStaff)
              this.$set(this.staffData, 'maintainEvaluateByStaff', res.maintainEvaluateByStaff)
              this.$set(this.staffData, 'feeReceive', res.feeReceive)
              this.$set(this.staffData, 'staffGardenGrid', res.staffGardenGrid)
              this.$set(this.staffData, 'parentMaintain', res.parentMaintain)
              this.$set(this.staffData, 'complainMaintain', res.complainMaintain)
              this.$set(this.staffData, 'maintainEvaluateUserByStaff', res.maintainEvaluateUserByStaff)
              this.$set(this.staffData, 'maintainInTimeFinishUserByStaff', res.maintainInTimeFinishUserByStaff)
              this.$set(this.staffData, 'userDrawCount', res.userDrawCount)
              this.$set(this.staffData, 'appBind', res.appBind)
              this.$set(this.staffData, 'oneDayMaintainCount', res.oneDayMaintainCount ? res.oneDayMaintainCount.oneDayMaintainCount : 0)
              this.$set(this.staffData, 'maintainPriceStaff', res.maintainPriceStaff)
              this.$set(this.staffData, 'serviceCommission', res.serviceCommission)
              this.$set(this.staffData, 'gbaJiedan', res.gbaJiedan)
              
              this.getJdjsl(this.staffData.maintainOverTimeByStaff)
              this.getGdfkl(this.staffData.maintainInTimeFinishByStaff)
              this.getGdhpl(this.staffData.maintainEvaluateByStaff)
              this.getWyfsjl(this.staffData.feeReceive)
              this.getYzhpl(this.staffData.maintainEvaluateUserByStaff)
              this.getYzwjl(this.staffData.maintainInTimeFinishUserByStaff)
              let pkArr = []
              let ldObj = {
                value: [res.yezhuMaintain, res.wuyeMaintain, res.jobMaintain, res.baodanMaintain, res
                  .jiedanMaintain, res.jujiafuwuMaintain
                ],
                name: res.staffName
              }
              pkArr.push(ldObj)
              this.pkArr = pkArr
              let nameArr = []
              nameArr.push(ldObj.name)
              this.nameArr = nameArr
              this.getLoadEcharts5(pkArr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取门禁电梯数据
      getDoorData() {
        let loading = this.$loading() 
        this.$get(
          `/selectStaffDataRecord?startTs=${this.startTs}&endTs=${this.endTs}&staffId=${this.staffId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.$set(this.staffData, 'doorDeviceRecordCount', res.doorDeviceRecordCount)
              this.$set(this.staffData, 'liftRecordCount', res.liftRecordCount)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取接单及时率数据
      getJdjsl(data) {
        if (data && data.length > 0) {
          this.getLoadEcharts1(data)
        } else {
          this.getLoadEcharts1(null)
        }
      },
      // 获取24小时反馈率数据
      getGdfkl(data) {
        if (data && data.length > 0) {
          this.getLoadEcharts2(data)
        } else {
          this.getLoadEcharts2(null)
        }
      },
      // 获取工单好评率数据
      getGdhpl(data) {
        if (data && data.length > 0) {
          this.getLoadEcharts3(data)
        } else {
          this.getLoadEcharts3(null)
        }
      },
      // 获取物业费收缴率数据
      getWyfsjl(data) {
        if (data) {
          let arr = []
          let isPay = {}
          let noPay = {}
          isPay.name = '实收'
          isPay.value = data.paid_amount.toFixed(0)
          noPay.name = '未收'
          noPay.value = (data.receive_amount - data.paid_amount).toFixed(0)
          if (isPay.value > 0) {
            arr.push(isPay)
          }
          if (noPay.value > 0) {
            arr.push(noPay)
          }
          this.getLoadEcharts4(arr)
        } else {
          this.getLoadEcharts4(null)
        }
      },
      // 获取业主好评率：（对应管理片区的好评量）
      getYzhpl(data) {
        if (data && data.length > 0) {
          this.getLoadEcharts6(data)
        } else {
          this.getLoadEcharts6(null)
        }
      },
      // 获取24H完结率：（对应管理片区的完结率）
      getYzwjl(data) {
        if (data && data.length > 0) {
          this.getLoadEcharts7(data)
        } else {
          this.getLoadEcharts7(null)
        }
      },
      // 获取接单及时率图表
      getLoadEcharts1(data) {
        if (!data) {
          var dom = document.getElementById('echart1')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart1 = this.$echarts.init(
            document.getElementById('echart1')
          )
          var option1 = {
            tooltip: {
              trigger: 'item'
            },
            color: ['#91cc75', '#F97F51'],
            legend: {
              bottom: '0',
              left: '0'
            },
            series: [{
              name: '接单及时率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                  // formatter: '{b}:{c}({d}%)',
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      // return '{name|{b}}\n{value|{d}%( {c})}'
                      return text + '\n' + param.data.value + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '(' + param.percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data
            }]
          }
          myChart1.setOption(option1)
        }
      },
      // 获取工单24小时反馈率统计图表
      getLoadEcharts2(data) {
        if (!data) {
          var dom = document.getElementById('echart2')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart2 = this.$echarts.init(
            document.getElementById('echart2')
          )
          var option2 = {
            tooltip: {
              trigger: 'item'
            },
            color: ['#91cc75', '#6a89cc', '#F97F51'],
            legend: {
              bottom: '0',
              left: '0'
            },
            series: [{
              name: '工单24小时反馈率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              center: ['50%', '50%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                  // formatter: '{b}:{c}({d}%)',
                  formatter: function (param) {
                    let text = param.data.name
                    if (text.length < 15) {
                      // return '{name|{b}}\n{value|{d}%( {c})}'
                      return text + '\n' + param.data.value + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '(' + param.percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 13
                  }
                }
              },
              data: data
            }]
          }
          myChart2.setOption(option2)
        }
      },
      // 获取工单好评率图表
      getLoadEcharts3(data) {
        if (!data) {
          var dom = document.getElementById('echart3')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart3 = this.$echarts.init(
            document.getElementById('echart3')
          )
          var option3 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: data.length > 2 ? ['#91cc75', '#6a89cc', '#F97F51', '9a60b4'] : ['#F97F51', '#6a89cc'],
            series: [{
              name: '工单好评率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart3.setOption(option3)
        }
      },
      // 获取物业费收缴率统计图表
      getLoadEcharts4(data) {
        if (!data) {
          var dom = document.getElementById('echart4')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart4 = this.$echarts.init(
            document.getElementById('echart4')
          )
          var option4 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#91cc75', '#F97F51'],
            series: [{
              name: '物业费收缴率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart4.setOption(option4)
        }
      },
      // 获取雷达图
      getLoadEcharts5(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart5')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart5 = this.$echarts.init(
            document.getElementById('echart5')
          )
          var option5 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              // data: ['Allocated Budget', 'Actual Spending', '张三'],
              data: this.nameArr,
              bottom: '-0',
              left: '0'
            },
            label: {
              // show: true // 显示数值
            },
            radar: {
              indicator: [{
                  name: '业主工单',
                  // max: 99999
                },
                {
                  name: '物业工单',
                  // max: 99999
                },
                {
                  name: '巡检工单',
                  // max: 99999
                },
                {
                  name: '报单数量',
                  // max: 99999
                },
                {
                  name: '接单数量',
                  // max: 99999
                },
                {
                  name: '居家服务工单',
                  // max: 99999
                }
              ],
              axisName: {
                color: '#6a89cc'
              },
            },
            series: [{
              name: 'Budget vs spending',
              type: 'radar',
              data: data
              // data: [{
              //     value: [1, 1, 1, 1, 1, 1],
              //     name: 'Allocated Budget'
              //   },
              //   {
              //     value: [2, 2, 2, 2, 2, 2],
              //     name: 'Actual Spending'
              //   },
              //   {
              //     value: [3, 3, 3, 3, 3, 3],
              //     name: '张三'
              //   }
              // ]
            }]
          }
          myChart5.setOption(option5)
        }
      },
      //  获取业主好评率：（对应管理片区的好评量）统计图表
      getLoadEcharts6(data) {
        if (!data) {
          var dom = document.getElementById('echart6')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart6 = this.$echarts.init(
            document.getElementById('echart6')
          )
          var option6 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#91cc75', '#F97F51'],
            series: [{
              name: '对应管理片区业主好评率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart6.setOption(option6)
        }
      },
      // 获取24H完结率：（对应管理片区的完结率）统计图表
      getLoadEcharts7(data) {
        if (!data) {
          var dom = document.getElementById('echart7')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart7 = this.$echarts.init(
            document.getElementById('echart7')
          )
          var option7 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#91cc75', '#F97F51'],
            series: [{
              name: '对应管理片区24H完结率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart7.setOption(option7)
        }
      },
    }
  }
</script>

<style lang="scss">
  .basicDataSummary {
    .mb20 {
      margin-bottom: 20px;
    }

    .h-300 {
      height: 300px !important;
    }

    .h-380 {
      height: 380px !important;
    }

    .cardTitle {
      font-size: 18px;
      padding-left: 10px;
      margin-left: 10px;
      margin-bottom: 30px;
      border-left: 3px solid #ff6207;
    }

    .topBox {
      display: flex;

      .topLeftBox {
        flex: 1;
        min-width: 520px;
        margin-bottom: 20px;

        .cardTitle {
          font-size: 18px;
          padding-left: 10px;
          margin-left: 10px;
          margin-bottom: 30px;
          border-left: 3px solid #ff6207;
        }

        .topLeftInfo {
          width: 100%;
          display: flex;
          flex-wrap: wrap;

          .wid100 {
            width: 100% !important;
            flex: 1 100% !important;
            // align-items: normal!important;
          }

          .leftFlex {
            flex: 1 17%;
            display: flex;
            flex-wrap: wrap;
            background-color: #f5f5f5;
            border-radius: 5px;
            margin: 0 10px 10px 0;
            padding: 6px 10px;
            box-sizing: border-box;
            align-items: center;

            .lebelText {
              font-size: 16px;
              flex: 1;
            }

            .infoText {
              padding: 0 5px;
              text-align: right;
              font-size: 28px;
              color: #00b1c3;
              margin-right: 15px;
            }

            .infoTag {
              font-size: 16px;
              margin: 5px 10px;
              color: #fff !important;
            }

            .infoText1 {
              padding: 0 5px;
              text-align: right;
              font-size: 28px;
              color: #b4d049;
              margin-right: 15px;
            }

            .infoText2 {
              padding: 0 5px;
              text-align: right;
              font-size: 28px;
              color: #ed8599;
              margin-right: 15px;
            }

            .bb {
              border-bottom: 3px solid #00b1c3;
            }

            .bb1 {
              border-bottom: 3px solid #b4d049;
            }

            .bb2 {
              border-bottom: 3px solid #ed8599;
            }
          }
        }

        .topLeftInfo::after {
          flex: 1 50%;
          content: '';
        }
      }

      .topRightBox {
        flex: 2;

        .container {
          width: 100%;
          height: 292px;
          margin-left: 30px;
        }
      }
    }

    .contentBox {
      display: flex;
      margin-bottom: 20px;

      .contentCard {
        flex: 1;
        margin-right: 20px;
      }

      .contentCard:last-child {
        margin-right: 0;
      }

      .container {
        width: 100%;
        height: 280px;
        margin-left: 30px;
      }

      .container1 {
        width: 100%;
        height: 380px;
        margin-left: 30px;
      }

      .gardenAge {
        margin-left: 24px;
        font-size: 18px;
        font-weight: bold;
        color: #999;

        span {
          font-size: 30px;
          color: #F97F51;
        }
      }
    }

    #echart1,
    #echart2,
    #echart3,
    #echart4,
    #echart5,
    #echart6,
    #echart7,
    #echart8,
    #echart9,
      {
      width: 90%;
      height: 100%;
    }

    #echart10,
    #echart11,
    #echart12,
    #echart13,
      {
      width: 90%;
      height: 100%;
    }

    .lineBox1 {
      display: flex;
      flex-wrap: wrap;
    }

    .box-card {
      width: 12vw;
      text-align: center;
      margin: 0 0px 20px 10px;
      min-width: 170px;
    }

    .cardTitle1 {
      font-size: 18px;
      font-weight: bold;
    }

    .cardCont {
      display: flex;
      align-items: center;
      font-size: 30px;
      font-weight: bold;
      margin: 10px 0;
      padding: 0 10px;
    }

    .cardImg {
      width: 3vw;
      height: 3vw;
    }

    .noImg {
      visibility: hidden;
    }

    .cardInfo {
      flex: 1;
      display: inline-block;
      margin-left: -2vw;
    }

    .lineBox1 .box-card,
    .lineBox2 .box-card {
      color: #00b1c3 !important;
    }

    .smallFont {
      font-size: 16px !important;
    }

    .smallFont1 {
      font-size: 24px !important;
    }

    .jump-btn {
      float: right;
    }
    
    .bg1{
      background-color: #00b1c3!important;
      border: 1px solid #00b1c3!important;
    }
    .bg2{
      background-color: #ed8599!important;
      border: 1px solid #ed8599!important;
    }
    .bg3{
      background-color: #b4d049!important;
      border: 1px solid #b4d049!important;
    }
  }
</style>